/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';

export default declareLinkedEntity({
    entity: "sourceGroupDefs",
    graphQL: "SourceGroupDef",
    name: "Source Group Definition",
    defaultOrder: ['priority', 'name'],
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    parentRelation: 'sourceGroupDefs',
    defaultTitle: (data) => {
        return data['name'];
    },
    dynamoPrefix: 'def',
    storageType: 'schema',
    onModify: ['channelDef'],
    fields: (types) => { return {
        id: {
            name: "Source Group Definition ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
            compositeKey: true,
        },
        channelDef: {
            name: "Application Definition",
            type: "relation",
            to: () => types['channelDefs'],
            defaultValue: (channelDef) => {
                return channelDef['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        channelDefVersion: {
            name: "Channel Definition Version",
            to: () => types['channelDefVersions'],
            type: "relation",
            defaultValue: (channelDef) => {
                return channelDef['channelDefVersion_id'];
            },
            required: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        priority: {
            name: "Order",
            type: "int",
            defaultValue: '3',
        },
        importance: {
            name: "Importance",
            type: "enum",
            defaultValue: '3',
            values: {
                '1': {
                    name: 'H1'
                },
                '2': {
                    name: 'H2'
                },
                '3': {
                    name: 'H3'
                },
                '4': {
                    name: 'H4'
                },
                '5': {
                    name: 'H5'
                },
            }
        },
        name: {
            name: "Name",
            type: "string",
            trim: true,
            translatable: true,
            defaultValue: "",
            required: true
        },
        description: {
            name: "Description",
            type: "text",
            translatable: true,
            defaultValue: ""
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
    }; },
    relations: (types) => { return {
    }; }

});
